// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.off-edit-header {
  flex-direction: row !important;
  justify-content: space-between;
  align-items: flex-end;
}

.off-edit-header__left {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.off-btn-delete-header {
  background-color: rgba(179, 43, 43, 0.1);
  border: 1px solid #b32b2b;
  border-radius: 20px;
  color: #ff6b6b;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 18px;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: fit-content;
}

.off-btn-delete-header:hover {
  background-color: #b32b2b;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(179, 43, 43, 0.25);
}

@media (max-width: 600px) {
  .off-edit-header {
    flex-direction: column !important;
    align-items: flex-start;
    gap: 16px;
  }
  .off-btn-delete-header {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/EditOfferingPage/EditOfferingPage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE;IACE,iCAAiC;IACjC,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".off-edit-header {\n  flex-direction: row !important;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.off-edit-header__left {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.off-btn-delete-header {\n  background-color: rgba(179, 43, 43, 0.1);\n  border: 1px solid #b32b2b;\n  border-radius: 20px;\n  color: #ff6b6b;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 18px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  height: fit-content;\n}\n\n.off-btn-delete-header:hover {\n  background-color: #b32b2b;\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(179, 43, 43, 0.25);\n}\n\n@media (max-width: 600px) {\n  .off-edit-header {\n    flex-direction: column !important;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  .off-btn-delete-header {\n    width: 100%;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
